import { render, staticRenderFns } from "./createLoyaltySmartMomentCard.vue?vue&type=template&id=5bcb2dfe&"
import script from "./createLoyaltySmartMomentCard.vue?vue&type=script&lang=js&"
export * from "./createLoyaltySmartMomentCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports